<template>
  <v-app fill-height :style="$alertme.bgContainer()">
    <Menu @changeMonitoramento="changeMonitoramento" />
    <v-main>
      <transition name="slide-right">
        <router-view :key="String($store.getters.hostActive)" />
      </transition>
      <v-btn color="white" style="border:1px solid #001e62;bottom:10px"  @click="openWhatsApp"  absolute bottom right fab >
        <v-icon color="primary">mdi-help</v-icon>
      </v-btn>
    </v-main>

    <v-bottom-sheet v-model="openMsgErr" width="100%">
      <v-sheet class="text-center" height="200px">
        <v-btn class="mt-6" text color="red" @click="openMsgErr = !openMsgErr"
          >fechar</v-btn
        >
        <div class="py-3" v-html="$store.getters.msgError"></div>
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog v-model="displayLoading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Aguarde...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :absolute="true" :value="displayChangeStatus">
      <v-dialog
        v-model="displayChangeStatus"
        elevation-0
        persistent
        max-width="300"
      >
        <v-card color="primary" dark>
          <v-card-text>
            Aguarde, processando operação...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-overlay :absolute="true" :value="dialoag_question_online">
      <v-dialog v-model="dialoag_question_online" persistent max-width="360">
        <v-card>
          <v-card-title class="headline" color="primary">Aviso</v-card-title>

          <v-card-text> Tem alguém monitorando as câmeras? </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1"
              text
              @click.prevent="closeDialogQuestionOnlineNo"
            >
              não
            </v-btn>

            <v-btn
              color="success darken-1"
              text
              @click.prevent="closeDialogQuestionOnlineOk"
            >
              Sim
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="displayMsgSuccess"
      absolute
      bottom
      left
      color="transparent"
      outlined
      text
      multi-line
      :timeout="5000"
    >
      <v-alert
        border="left"
        colored-border
        color="#009c3b"
        dismissible
        @click="closeMsg"
        elevation="1"
      >
        {{ MsgSucces }}
      </v-alert>
    </v-snackbar>
  </v-app>
</template>
<style lang="scss">
.white-text {
  fill: #fff !important;
}
.v-snack__wrapper.theme--dark{
  background: transparent;
}
.v-snack__wrapper.theme--light{
  background: transparent;
}
html {
  overflow-y: auto;
}
* {
  scrollbar-width: thin;
  // scrollbar-color: #c4c4c4 transparent;
  scrollbar-color: #cecece #eaeaea;
  // scrollbar-color: #cecece transparent;
}

/// Works on Chrome, Edge, and Safari
*::-webkit-scrollbar {
  width: 5px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 20px;
  border: 3px solid transparent;
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.3) !important;
}
.w-100 {
  width: 100%;
}
</style>
<script>
import Menu from "@/views/Menu.vue";
import { uuidv4 } from "@/services/utils";
import { mapGetters } from "vuex";
// import { existsProp } from "./services/utils";

export default {
  name: "App",
  components: {
    Menu,
  },
  data() {
    return {
      titulo: "",
      event: null,
      tabFocus: false,
      event_timeout: null,
      event_timeout_question: null,
      event_wait_click: null,
      dialoag_question_online: false,
      displayChangeStatus: false,
    };
  },
  computed: {
    ...mapGetters([
      "displayLoading",
      "MsgSucces",
      "isLogin",
      "totalCamsConfigurada",
    ]),
    displayMsgSuccess: {
      set(value) {
        this.$store.dispatch("displayMsgSuccess", value);
      },
      get() {
        return this.$store.getters.displayMsgSuccess;
      },
    },
    openMsgErr: {
      set(value) {
        this.$store.dispatch("setDisplayMsgErr", value);
      },
      get() {
        return this.$store.getters.displayMsgErr;
      },
    },
  },
  methods: {
    openWhatsApp(){
      this.$alertme.openSuporte()
    },
    detectFocusOut() {
      let inView = false;
      const onWindowFocusChange = (e) => {
        if ({ focus: 1, pageshow: 1 }[e.type]) {
          if (inView) return;
          this.tabFocus = true;
          inView = true;
        } else if (inView) {
          this.tabFocus = !this.tabFocus;
          inView = false;
        }
      };
      window.addEventListener("focus", onWindowFocusChange);
      window.addEventListener("blur", onWindowFocusChange);
      window.addEventListener("pageshow", onWindowFocusChange);
      window.addEventListener("pagehide", onWindowFocusChange);
    },

    resolveStarStopMonitor(inView) {
      if (!this.$store.getters.isLogin) {
        this.clearTimesOut();
        return;
      }
      if (inView) {
        this.$root.addFindMessageServer(3000);
      }
       if(this.$alertme.getHostIdUrl(this.$route) ==null) {
          return this.$router.push({
                name: 'home',
                params: { hostId: this.$store.getters.hostActive }
              });
      }
      this.addEventInitMonitoramento();
      this.addEventInatividade();
    },
    addEventInitMonitoramento() {
      if (this.totalCamsConfigurada <= 0) {
        return false;
      }
      this.event_timeout = setTimeout(() => {
        this.$root.initMonitorStatusCam();
        clearTimeout(this.event_timeout);
        this.event_timeout = null;
      }, 15000);
    },
    addEventInatividade() {
      if (this.totalCamsConfigurada <= 0) {
        return false;
      }
      if (this.event_timeout_question == null) {
        this.event_timeout_question = setTimeout(() => {
          if (!this.$store.getters.isLogin) {
            this.event_timeout_question = null;
            return;
          }
          this.dialoag_question_online = true;
          clearTimeout(this.event_timeout_question);
          this.event_timeout_question = null;
        }, 3000000); // 6000000//10minutos
      }
    },
    clearTimesOut() {
      if (this.event_timeout_question != null) {
        clearTimeout(this.event_timeout_question);
      }
      if (this.event_timeout != null) {
        clearTimeout(this.event_timeout);
      }
      if (this.event_wait_click != null) {
        clearTimeout(this.event_wait_click);
      }
      this.event_timeout_question = null;
      this.event_timeout = null;
      this.event_wait_click = null;
    },
    closeDialogQuestionOnlineNo() {
      this.dialoag_question_online = false;
      this.$alertme.signOut(this.$store.getters.hostActive);
      this.$root.stopMonitorStatusCam();
    },
    closeDialogQuestionOnlineOk() {
      this.dialoag_question_online = false;
      this.addEventInatividade();
      this.$root.initMonitorStatusCam();
    },
    getDate() {
      let datetime = new Date();
      let split = datetime.toISOString().split("T");
      return split[0] + " " + split[1].split(".")[0];
    },
    uuid() {
      return uuidv4();
    },
    changeMonitoramento() {
      this.displayChangeStatus = true;
      //
      let event_name = "operation-90";
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$store.getters.hostActive,
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: {
            operation: 90,
            data: this.$store.getters.getStatusCams ? "stop" : "start",
          },
        },
        false,
        (res) => {
          if (res.data.message == "ok") {
            this.$store.dispatch("setStatusCams", null);
          } else {
            this.$store.dispatch(
              "setMsgError",
              "Não foi possível realizar operação!"
            );
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        }
      );
      this.$root.$on(event_name, (obj) => {
        this.$store.dispatch("setListStatusCams", [...obj.result.cameras]);
        this.displayChangeStatus = false;
      });
    },
    closeMsg() {
      this.displayMsgSuccess = false;
      this.$store.dispatch("MsgSucces", "");
      this.$store.dispatch("btnMsg", "fechar");
      let redirect = this.$store.getters.getRedirect;
      if (
        redirect != "" &&
        Object.prototype.hasOwnProperty.call(redirect, "name")
      ) {
        this.$router.push(redirect).catch(() => {});
      }
    },
  },
  watch: {
    tabFocus(value) {
      this.resolveStarStopMonitor(value);
    },
    dialoag_question_online(value) {
      if (value) {
        this.event_wait_click = setTimeout(() => {
          this.closeDialogQuestionOnlineNo();
        }, 600000); //10minutos
      } else {
        if (this.event_wait_click != null) {
          clearTimeout(this.event_wait_click);
        }
        this.event_wait_click = null;
      }
    },
    isLogin(value) {
      if (value) {
        this.resolveStarStopMonitor(true);
      }
    },
    totalCamsConfigurada(value) {
      if (value > 0) {
        this.addEventInatividade();
        this.addEventInitMonitoramento();
      }
    },
    $route() {
      if (
        this.event_timeout_question != null ||
        this.event_timeout_question != undefined
      ) {
        clearTimeout(this.event_timeout_question);
      }
      if(this.$store.getters.isLogin==false) {
        return this.$router.push({ path: '/login',hash:'' }).catch(()=>{})
      }
      if (this.totalCamsConfigurada <= 0) {
        return;
      }
      this.event_timeout_question = null;
      this.addEventInatividade();
    },
  },
  created() {
    if(this.$store.getters.isLogin==false) {
      return this.$router.push({ path: '/login' })
    }
    this.$store.dispatch("loadPreferenciasUser");
    this.detectFocusOut();
    this.addEventInatividade();
    //
    this.$on("resetDialogOnline", () => {
      if (
        this.event_timeout_question != null &&
        this.event_timeout_question != undefined
      ) {
        clearTimeout(this.event_timeout_question);
        this.event_timeout_question = null;
      }
      this.addEventInatividade();
    });
    //
    this.$store.dispatch("setCams", []);
    this.$store.dispatch("setListStatusCams", []);
    this.$store.dispatch("setStatusCams", null);
  },
};
</script>
